module.exports = __webpack_public_path__ + "3a3c875a6fcc347a945085f51f0f5557.svg";